import useLocation from "@store/Hooks/Pages/useLocation";

const useCurrentSearch = () => {
    return useLocation().search;
};

export default useCurrentSearch;
